import { useCachedResource } from "../hooks/useCachedResource";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { NeuCard } from "../components/neu/Neu";
import { myBonuses } from "../api/bonuses";
import { MyBonusList } from "../features/bonuses/MyBonusList";

export default function MyBonusesPage() {
  const { t } = useTranslation();
  const { data: raw, reload: load } = useCachedResource(
    "my-bonuses", () => myBonuses().catch(() => ({ items: [], awaiting: [] })));
  const data = raw || { items: [], awaiting: [] };

  return (
    <AppShell title={t("bonus.mineTitle")} subtitle={t("bonus.mineSubtitle")}>
      <div className="grid gap-5" data-testid="my-bonuses-page">
        {data.awaiting?.length ? (
          <NeuCard className="border-2 border-yellow-500/40 p-4 text-sm font-black text-yellow-600"
                   data-testid="bonus-awaiting-banner">
            {t("bonus.awaitingBanner", { source: data.awaiting[0].payment_source_name })}
          </NeuCard>
        ) : null}
        <MyBonusList rows={data.items || []} onChanged={load} />
      </div>
    </AppShell>
  );
}
